import React, { Component } from "react";
import { Link } from "react-router-dom";
import JejakinLogo_adoption from "./../../../gogreener_adoptree_jejakin.svg";
import Icon from "react-icons-kit";
import { ic_close } from "react-icons-kit/md/ic_close";
import { images } from "react-icons-kit/icomoon/images";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import icon_1 from "./../../../images/icon/1.svg";
import icon_2 from "./../../../images/icon/2.svg";
import icon_tree from "./../../../images/icon/tree.png";
import icon_download from "./../../../images/icon/icon_download.svg";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import moment from "moment";
import "moment/locale/id";
import "moment/locale/en-au";
// import InfiniteScroll from "react-infinite-scroll-component";
import "react-toastify/dist/ReactToastify.css";
import "./Profile.scss";
import ContentLoader from "react-content-loader";
import { Translation } from "react-i18next";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination } from "swiper";
import "swiper/swiper.scss";
import "swiper/components/pagination/pagination.scss";
SwiperCore.use([Pagination]);

// import i18n from './../../../i18next';
var QRCode = require("qrcode.react");

const CardLoaderFull = () => (
   <ContentLoader height={300}>
      <rect x='0' y='0' rx='6' ry='6' width='100%' height='280' />
   </ContentLoader>
);
const CardLoaderCertificate = () => (
   <ContentLoader height={280}>
      <rect x='0' y='0' rx='6' ry='6' width='100%' height='260' />
   </ContentLoader>
);

const CardLoaderBox = () => (
   <ContentLoader height={120}>
      <rect x='0' y='0' rx='6' ry='6' width='100%' height='100' />
   </ContentLoader>
);
class ProfileTreeDetailAdoption extends Component {
   constructor(props) {
      super(props);
      this.state = {
         status: true,
         loggedIn: false,
         error: null,
         loaderButton: false,
         loading: true,
         lang: "en",
         programId: null,
         treeSummaryId: null,
         history: {},
         modalImg: false,
         selectedImg: null,
         certificate_loading: true,
         certificate_exist: true,
         certificate_name: null,
         certificate_path:
            process.env.REACT_APP_TREE_QUERY + "/file/adoption-certificate",
      };
   }

   componentDidMount() {
      moment.locale(window.localStorage.i18nextLng);
      this.setState({ lang: window.localStorage.i18nextLng });
      this.getDetailHistory(this.props.match.params.idtreehistory);
   }

   getDetailHistory = (id) => {
      axios
         .get(process.env.REACT_APP_API_HOST + "/tree/detail-history/" + id)
         .then((res) => {
            console.log("history detail ", res.data);
            if (res.data.status) {
               setTimeout(() => {
                  this.setState(
                     {
                        history: res.data.data,
                        programId: res.data.data.programId,
                        loading: false,
                     },
                     () => {
                        this.getCertificate(
                           this.props.match.params.idprofile,
                           res.data.data.programId,
                           res.data.data.treeId
                        );
                     }
                  );
               }, 1000);
            } else {
               this.setState({
                  status: false,
                  error: res.data.error,
                  loading: false,
               });
            }
         });
   };
   getCertificate = (idprofile, idprogram, idtree) => {
      // treeid-programid-userid
      axios
         .get(
            process.env.REACT_APP_API_SYLLOGI +
               "/file/adoption-certificate/" +
               idtree +
               "-" +
               idprogram +
               "-" +
               idprofile +
               ".png"
         )
         .then((res) => {
            console.log("get certificate", res.data);
            if (res.data) {
               console.log("res data");
               if (res.data.data === false) {
                  console.log("false");
                  this.setState({
                     certificate_loading: false,
                     certificate_name: null,
                  });
               } else {
                  this.setState({
                     certificate_loading: false,
                     certificate_name:
                        idtree + "-" + idprogram + "-" + idprofile + ".png",
                  });
               }
            } else {
               console.log("else res data");
               if (res.data.data === false) {
                  this.setState({
                     certificate_loading: false,
                     certificate_name: null,
                  });
               } else {
                  this.setState({
                     certificate_loading: false,
                     certificate_name:
                        idtree + "-" + idprogram + "-" + idprofile + ".png",
                  });
               }
            }
         });
   };

   render() {
      return (
         <>
            <div className='header no-print'>
               <div className='nav nav-main-top'>
                  <div className='container'>
                     <div className='row'>
                        <div className='col-sm-12'>
                           <div className='logo-img'>
                              <img src={JejakinLogo_adoption} alt='Jejak.in' />
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div className='mpl-page'>
               <div
                  className={
                     this.state.modalImg ? "wrap-modal show" : "wrap-modal"
                  }
               >
                  <div
                     className='box-close'
                     onClick={() => {
                        this.setState({ modalImg: false, selectedImg: null });
                     }}
                  >
                     &nbsp;
                  </div>
                  <div className='box-modal'>
                     <div className='box-modal-img'>
                        <span
                           className='bx-icon'
                           style={{ cursor: "pointer", color: "#111" }}
                           onClick={() => {
                              this.setState({
                                 modalImg: false,
                                 selectedImg: null,
                              });
                           }}
                        >
                           <Icon size={22} icon={ic_close} />
                        </span>
                        <img src={this.state.selectedImg} alt='Test' />
                     </div>
                  </div>
               </div>
               <ToastContainer />
               {this.state.loading ? (
                  <div className='container'>
                     <div className='row'>
                        <div className='col-sm-12'>
                           <br /> <br />
                           <CardLoaderFull />
                        </div>
                     </div>
                     <div className='row'>
                        <div className='col-6'>
                           <CardLoaderBox />
                        </div>
                        <div className='col-6'>
                           <CardLoaderBox />
                        </div>
                        <div className='col-12'>
                           <CardLoaderCertificate />
                        </div>
                        <div className='col-6'>
                           <CardLoaderBox />
                        </div>
                        <div className='col-6'>
                           <CardLoaderBox />
                        </div>
                        <div className='col-6'>
                           <CardLoaderBox />
                        </div>
                        <div className='col-6'></div>
                     </div>
                     <div className='row'>
                        <div className='col-sm-12'>
                           <br />
                           <CardLoaderFull />
                        </div>
                     </div>
                  </div>
               ) : (
                  <Translation>
                     {(t, { i18n }) => (
                        <div className='container'>
                           <div className='row'>
                              <div className='col-sm-12'>
                                 <ul className='breadcrumb'>
                                    <li className='breadcrumb-item'>
                                       <Link
                                          to={
                                             "/profile/" +
                                             this.props.match.params.idprofile
                                          }
                                       >
                                          {t("Report")}
                                       </Link>
                                    </li>
                                    <li className='breadcrumb-item'>
                                       <Link
                                          to={
                                             "/profile/" +
                                             this.props.match.params.idprofile +
                                             "/" +
                                             this.state.programId +
                                             "/program-adoption"
                                          }
                                       >
                                          {t("ReportDetail")}
                                       </Link>
                                    </li>
                                    <li className='breadcrumb-item'>
                                       <span>{t("Tree")}</span>
                                    </li>
                                 </ul>
                              </div>
                           </div>
                           <div className='row'>
                              <div className='col-sm-12'>
                                 <div className='tree-detail-wrap'>
                                    <div className='card card-white'>
                                       {this.state.history.listImgUrl.length !==
                                       0 ? (
                                          <div className='slide-modal mb-5'>
                                             <Swiper
                                                className='normal'
                                                pagination={{ clickable: true }}
                                                spaceBetween={5}
                                                centeredSlides={true}
                                                onSwiper={(swiper) =>
                                                   console.log(
                                                      "Onboarding loaded"
                                                   )
                                                }
                                             >
                                                {this.state.history.listImgUrl.map(
                                                   (img, idx) => {
                                                      return (
                                                         <SwiperSlide key={idx}>
                                                            <div className='swiper-slide'>
                                                               <div className='img-wrap big'>
                                                                  <LazyLoadImage
                                                                     effect='blur'
                                                                     onClick={() => {
                                                                        this.setState(
                                                                           {
                                                                              modalImg: true,
                                                                              selectedImg:
                                                                                 process
                                                                                    .env
                                                                                    .REACT_APP_IMAGE_PATH +
                                                                                 "/" +
                                                                                 img,
                                                                           }
                                                                        );
                                                                     }}
                                                                     src={
                                                                        process
                                                                           .env
                                                                           .REACT_APP_IMAGE_PATH +
                                                                        "/" +
                                                                        img
                                                                     }
                                                                     className='img-responsive rad-10'
                                                                     alt='History Img'
                                                                  />
                                                               </div>
                                                            </div>
                                                         </SwiperSlide>
                                                      );
                                                   }
                                                )}
                                             </Swiper>
                                          </div>
                                       ) : (
                                          <div className='no-image text-center'>
                                             <span>
                                                <Icon size={26} icon={images} />
                                                <br />
                                                <small>
                                                   {t(
                                                      "ThereIsNoDataMonitoring"
                                                   )}
                                                </small>
                                             </span>
                                          </div>
                                       )}
                                       <div className='tree-detail'>
                                          <div className='card-icon'>
                                             <div className='icon'>
                                                <img src={icon_1} alt='' />
                                             </div>
                                             <div className='text'>
                                                <h4 className='black'>
                                                   {
                                                      this.state.history
                                                         .infoPertumbuhanBatangUtama
                                                   }{" "}
                                                   cm
                                                </h4>
                                                <span>
                                                   {t("TrunkDiameter")}
                                                </span>
                                             </div>
                                          </div>
                                          <div className='card-icon'>
                                             <div className='icon'>
                                                <img src={icon_2} alt='' />
                                             </div>
                                             <div className='text'>
                                                <h4 className='black'>
                                                   {
                                                      this.state.history
                                                         .infoTinggiPohon
                                                   }{" "}
                                                   cm
                                                </h4>
                                                <span>{t("TreeHeight")}</span>
                                             </div>
                                          </div>
                                          <div className='card-icon'>
                                             <div className='icon'>
                                                <img src={icon_tree} alt='' />
                                             </div>
                                             <div className='text'>
                                                <h4 className='black'>
                                                   {this.state.history
                                                      .infoWarnaDaun === 1 ? (
                                                      <span className='bdg bdg-outline bdg-outline-brown'>
                                                         {t("Brown")}
                                                      </span>
                                                   ) : this.state.history
                                                        .infoWarnaDaun === 2 ? (
                                                      <span className='bdg bdg-outline bdg-outline-yellow'>
                                                         {t("Yellow")}
                                                      </span>
                                                   ) : (
                                                      <span className='bdg bdg-outline bdg-outline-green'>
                                                         {t("Green")}
                                                      </span>
                                                   )}
                                                </h4>
                                                <span>{t("LeafColor")}</span>
                                             </div>
                                          </div>
                                          <div className='card-icon'>
                                             <div className='icon'>
                                                <img src={icon_tree} alt='' />
                                             </div>
                                             <div className='text'>
                                                <h4 className='black'>
                                                   {this.state.history
                                                      .statusTree === 1 ? (
                                                      <span className='bdg bdg-grey'>
                                                         {t("Dead")}
                                                      </span>
                                                   ) : this.state.history
                                                        .statusTree === 2 ? (
                                                      <span className='bdg bdg-red'>
                                                         {t("Pest")}
                                                      </span>
                                                   ) : this.state.history
                                                        .statusTree === 3 ? (
                                                      <span className='bdg bdg-yellow'>
                                                         {t("Dry")}
                                                      </span>
                                                   ) : (
                                                      <span className='bdg bdg-green'>
                                                         {t("Good")}
                                                      </span>
                                                   )}
                                                </h4>
                                                <span>{t("Status")}</span>
                                             </div>
                                          </div>
                                          <div className='card-icon'>
                                             <div className='icon'>
                                                <img
                                                   src={icon_download}
                                                   alt=''
                                                />
                                             </div>
                                             <div
                                                className='text'
                                                style={{
                                                   display: "block",
                                                   width: "100%",
                                                }}
                                             >
                                                {this.state
                                                   .certificate_loading ? (
                                                   <>
                                                      <div className='col-12'>
                                                         <CardLoaderCertificate />
                                                      </div>
                                                   </>
                                                ) : (
                                                   <>
                                                      {this.state
                                                         .certificate_name ? (
                                                         <>
                                                            <div className='row'>
                                                               <div className='col-12'>
                                                                  <div className='wrap-certificate'>
                                                                     <LazyLoadImage
                                                                        className='certificate'
                                                                        style={{
                                                                           minHeight:
                                                                              "175px",
                                                                        }}
                                                                        effect='blur'
                                                                        src={
                                                                           this
                                                                              .state
                                                                              .certificate_path +
                                                                           "/" +
                                                                           this
                                                                              .state
                                                                              .certificate_name
                                                                        }
                                                                        alt={
                                                                           "Certificate"
                                                                        }
                                                                        onClick={() => {
                                                                           this.setState(
                                                                              {
                                                                                 modalImg: true,
                                                                                 selectedImg:
                                                                                    this
                                                                                       .state
                                                                                       .certificate_path +
                                                                                    "/" +
                                                                                    this
                                                                                       .state
                                                                                       .certificate_name,
                                                                              }
                                                                           );
                                                                        }}
                                                                     />
                                                                  </div>
                                                                  <div className='text-center mb-4'>
                                                                     <a
                                                                        className='btn-download'
                                                                        href={
                                                                           this
                                                                              .state
                                                                              .certificate_path +
                                                                           "/" +
                                                                           this
                                                                              .state
                                                                              .certificate_name
                                                                        }
                                                                        download='Certificate.png'
                                                                        target='_blank'
                                                                        rel='noopener noreferrer'
                                                                     >
                                                                        Download
                                                                     </a>
                                                                  </div>
                                                               </div>
                                                            </div>
                                                         </>
                                                      ) : (
                                                         <>
                                                            <h4 className='black'>
                                                               N/A
                                                            </h4>
                                                            <span>
                                                               {t(
                                                                  "Certificate"
                                                               )}
                                                            </span>
                                                         </>
                                                      )}
                                                   </>
                                                )}
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div className='row'>
                              <div className='col-6'>
                                 <h4 className='mt-0 mb-2'>
                                    {t("DateOfDataTaken")}
                                 </h4>
                                 <p className='mt-2'>
                                    {moment(
                                       this.state.history.createdAt
                                    ).format("ll")}
                                 </p>
                              </div>
                              <div className='col-6'>
                                 <span
                                    style={{ width: "80px", float: "right" }}
                                 >
                                    <QRCode
                                       value={
                                          process.env.REACT_APP_QR_PATH +
                                          "/?id=" +
                                          this.state.history.treeId
                                       }
                                       size={80}
                                       level={"L"}
                                    />
                                 </span>
                              </div>

                              <div className='col-12'>
                                 <h4 className='mt-0 mb-2'>
                                    {t("Description")}
                                 </h4>
                                 <p className='mt-2'>
                                    {this.state.history.issueDescription}
                                 </p>
                              </div>
                           </div>
                        </div>
                     )}
                  </Translation>
               )}
            </div>
         </>
      );
   }
}

export default ProfileTreeDetailAdoption;
